import { createHash } from 'crypto';
import { BRAND_NAME, LEAD_REGISTRATION_API } from '../../helpers/constants';
import { setCookie } from '../../helpers/cookie';

export function highlightInvalidFields(leadInfo = {}) {
  Object.values(leadInfo).forEach((value) => {
    if (!value.valid && value.selector) {
      document.querySelector(value.selector).classList.add('is-invalid');
    }
  });
}

export function onFocus(event) {
  if (event.target.classList.contains('is-invalid')) {
    event.target.classList.remove('is-invalid');
  }
}

export function isLeadInfoValid(info) {
  return (info
            && Object.keys(info).length
            && Object.values(info).every(value => value.valid));
}

function hash(string) {
  return createHash('sha256').update(string).digest('hex');
}

function pushRegistrationToGA4DataLayer(brandName, leadId) {
  if (window.dataLayer) {
    window.dataLayer.push({
      brand: brandName,
      source: 'internal',
      event: 'purchase',
      ecommerce: {
        transaction_id: leadId,
        affiliation: 'Leads',
        value: 0.00,
        tax: 0.00,
        shipping: 0.00,
        currency: '',
        coupon: '',
        items: [{
          item_name: 'Leads',
          item_id: leadId,
          Price: 0.00,
          item_brand: '',
          item_category: 'Website Leads',
          item_category_2: '',
          item_category_3: '',
          item_category_4: '',
          item_category_5: '',
          item_variant: '',
          quantity: 1,
        }],
      },
    });
  }
}

export function pushRegInfoToGTM(response) {
  window.localStorage.setItem('gtmData', JSON.stringify([{
    source: response.source,
    medium: response.medium,
    campaign: response.campaign,
    term: response.term,
    gclid: response.gclid,
    event: 'Registration',
    transactionId: response.UniquePIN,
    transactionAffiliation: 'Registration',
    transactionTotal: 0,
    transactionShipping: 0,
    transactionTax: 0,
    transactionCurrency: 'USD',
    transactionProducts: [{
      sku: 'Lead',
      category: '',
      name: 'Lead',
      price: 0,
      quantity: 1,
    }],
    contact_name: hash(response.fullName),
    contact_email: hash(response.email),
    contact_phone: hash(response.phone),
  }]));

  pushRegistrationToGA4DataLayer(BRAND_NAME, response.UniquePIN);
}

export async function makeLeadRegistrationRequest(
  payload = {},
  successCallback = () => {},
  failureCallback = () => {},
) {
  try {
    let response = await window.fetch(LEAD_REGISTRATION_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    response = await response.json();

    if (response && Object.keys(response).length) {
      const {
        UniquePIN, signupurl,
      } = response;

      if (UniquePIN && signupurl) {
        pushRegInfoToGTM(response);
        setCookie('isregistered', true, 365);
        setCookie('uniquePin', UniquePIN, 365);
        successCallback(response);
      } else {
        failureCallback(response);
      }
    } else {
      failureCallback(response);
    }
  } catch (e) {
    console.error(e); // eslint-disable-line
    failureCallback();
  }
}

export function setPhoneFlagAttributes() {
  const flagContainer = document.querySelector('.iti__flag-container');
  const selectedFlag = document.querySelector('.iti__selected-flag');
  if (flagContainer) {
    flagContainer.setAttribute('aria-label', 'Country code');
  }

  if (selectedFlag) {
    selectedFlag.setAttribute('role', 'button');
    selectedFlag.setAttribute('aria-haspopup', 'true');
  }
}

export function hideLeadRegisterFold() {
  const leadRegistrationFold = document.getElementById('registration');
  if (leadRegistrationFold) {
    leadRegistrationFold.classList.add('d-none');
  }
}

export function getRefinedLeadInfo(leadInfo = {}) {
  return Object.values(leadInfo).reduce((prevValue, currentValue) => {
    const prevValueRef = prevValue;
    const { value, emittedBy } = currentValue;
    if (emittedBy === 'phone') {
      const { dialCode, nationalNumber } = currentValue;
      prevValueRef.countryCode = dialCode;
      prevValueRef.phone = nationalNumber;
    } else {
      prevValueRef[emittedBy] = value;
    }
    return prevValueRef;
  }, {});
}

export function showPlansFold(uniquePin) {
  const plansFold = document.querySelector('#plans-wrapper');
  const leadRegistrationFold = document.querySelector('#intake-bottom-reg-fold');

  const updateLinkWithUniquePin = (element) => {
    if (element) {
      const originalLink = element.getAttribute('href');
      const updatedLink = originalLink.replace('directSignup=true', `leadUniquePin=${uniquePin}`);
      element.setAttribute('href', updatedLink);
    }
  };

  if (plansFold) {
    if (uniquePin) {
      ['#planOneLink', '#planTwoLink', '#planThreeLink', '#planFourLink', '#planFiveLink', '#planSixLink', '#planSevenLink', '#planEightLink'].forEach((selector) => {
        updateLinkWithUniquePin(document.querySelector(selector));
      });
    }
    plansFold.classList.remove('d-none');
  }
  if (leadRegistrationFold) {
    leadRegistrationFold.classList.add('d-none');
  }
}
